import React, { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Input,
  notification,
  Row,
  // Space,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import walkersService from "../../../services/walkers.service";
import moment from "moment";
// import "../TicketScan.scss";
const ChildrenScan = ({ router }) => {
  const [loading, setLoading] = useState(false);
  const [ticketId, setTicketId] = useState();
  const [data, setData] = useState();
  const [valid, setValid] = useState(false);
  const [errMessage, setErrMessage] = useState();
  const renderTicket = (data) => {
    const datas = [
      {
        title: "Child Tag ID",
        value: <b>{data?.childUser?.childrenTagId}</b>,
      },
      {
        title: "Child Name",
        value: data?.childUser?.name,
      },
      {
        title: "Father Name",
        value: data?.childUser?.fatherName,
      },
      {
        title: "Gender",
        value: data?.childUser?.gender,
      },
      {
        title: "Address",
        value: data?.childUser?.address,
      },
      {
        title: "Mobile",
        value: data?.childUser?.mobile,
      },

      {
        title: "Created At",
        value: moment(data?.childUser?.createdAt).format(
          "DD-MM-YYYY hh:mm:ss A"
        ),
      },
      {
        title: "Updated At",
        value: moment(data?.walkerUser?.updatedAt).format(
          "DD-MM-YYYY hh:mm:ss A"
        ),
      },
    ];
    return datas.map((item, index) => {
      return (
        <Row style={{ marginBottom: "5px" }} key={"ticketdetails" + index}>
          <Col className="ticket_label">{item.title}:</Col>
          <Col className="ticket_data">{item?.value}</Col>
        </Row>
      );
    });
  };
  const ticketScan = async () => {
    setValid(false);
    setErrMessage(undefined);
    setLoading(true);
    if (!ticketId) {
      notification.error({ message: "Enter Child Tag ID!" });
    }

    try {
      const data = await walkersService.getChildTagScanner(ticketId);
      if (data) {
        setData(data);
      }
      setTicketId("");
      if (!data?.success) {
        setErrMessage(data?.message);
      }
      setValid(data?.success);
      setLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        setValid(false);
        setErrMessage(error?.response?.data?.message);
      }
      setTicketId("");
      catchErrorFunction(error, "Token expired!! Login again.", router);
      setLoading(false);
    }
  };

  const onChangeTicketId = (e) => {
    setTicketId(e.target.value);
    setValid(false);
    setErrMessage(undefined);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      ticketScan();
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title> Child Tag Scan </Typography.Title>
      </Row>
      <Row justify="center">
        <Col
          className="mobile-responsive-width"
          style={{ margin: "8px", textAlign: "left" }}
        >
          {" "}
          Child Tag Id:{" "}
        </Col>
        <Col className="mobile-responsive-width" style={{ margin: "8px" }}>
          <Input
            maxLength={220}
            value={ticketId}
            onChange={onChangeTicketId}
            onKeyDown={onKeyDown}
            className="mobile-responsive-width"
          />
        </Col>
        <Col className="mobile-responsive-width" style={{ margin: "8px" }}>
          <Button
            className="mobile-responsive-width"
            type="primary"
            onClick={ticketScan}
            loading={loading}
          >
            GO!
          </Button>
        </Col>
      </Row>
      <Row justify="center" style={{ margin: "20px" }}>
        {valid && data && (
          <Alert
            message={`Tag Scanned ${data?.[0]?.ticketId ?? ""}`}
            description={`Tag has been scanned successfully.`}
            type="success"
            showIcon
          />
        )}
        {!valid && errMessage && (
          <Alert
            style={{
              paddingRight: "30px",
              backgroundColor: "red",
              color: "white",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              padding: "25px",
            }}
            message={
              <span
                style={{
                  color: "white",
                  fontSize: "30px",
                }}
              >
                Error Scanning Ticket {data?.[0]?.ticketId ?? ""}
              </span>
            }
            description={errMessage}
            type="error"
          />
        )}
      </Row>
      {valid && data && (
        <Row>
          <Col span={12} style={{ textAlign: "left", fontSize: "14px" }}>
            <Card>{renderTicket(data)} </Card>
          </Col>
          <Col span={12} style={{ padding: "0px 10px", fontSize: "14px" }}>
            <Card>
              <img src={data?.childUser?.childPhotoUrl} alt="" />
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default withRouter(ChildrenScan);
